import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesSupportChatMain } from './modules/ui/Main';

const SupportChatPage = (
  <SuspensePage>
    <PagesSupportChatMain />
  </SuspensePage>
);

export default SupportChatPage;
